package com.tovtalk.ui.theme

import androidx.compose.runtime.Immutable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

/**
 * Material 3 elevation levels - shared across Android, iOS, Web.
 * Use with Surface(elevation = ...) for cards, app bars, dialogs.
 */
@Immutable
data class TovTalkElevationSystem(
    val none: Dp,
    val level1: Dp,
    val level2: Dp,
    val level3: Dp,
    val level4: Dp,
    val level5: Dp,
    val card: Dp,
    val topBar: Dp,
    val bottomBar: Dp,
    val dialog: Dp,
    val sheet: Dp,
)

val TovTalkElevation = TovTalkElevationSystem(
    none = 0.dp,
    level1 = 1.dp,
    level2 = 3.dp,
    level3 = 6.dp,
    level4 = 8.dp,
    level5 = 12.dp,
    card = 1.dp,
    topBar = 0.dp,
    bottomBar = 8.dp,
    dialog = 6.dp,
    sheet = 16.dp,
)

val LocalTovTalkElevation = staticCompositionLocalOf { TovTalkElevation }
